import { Badge, Table } from "react-bootstrap";
import { formatDate } from "../../helpers/utils";

const TableRow = ({ data, viewEntry, updateEntry, deleteEntry, user = {},sr }) => {
  return (
    <tr className="text-center">
      <td>{sr}</td>

      <td
        onClick={() => viewEntry(data)}
        className="text-primary"
        style={{ cursor: "pointer" }}
      >
        {data.first_name || "—"} {data.last_name || ""}
      </td>

      <td>{data.email || "—"}</td>
      <td>{data.phone || "—"}</td>
      <td>{data.user_name || "—"}</td>
      <td>{data.referral_code || "—"}</td>
      <td>{data.reference_by_code || "—"}</td>

      <td>
        {data.roleObj ? (
          <Badge bg={data.roleObj.type}>{data.roleObj.title}</Badge>
        ) : (
          "—"
        )}
      </td>

      <td>
        {data.statusObj ? (
          <Badge bg={data.statusObj.type}>{data.statusObj.title}</Badge>
        ) : (
          "—"
        )}
      </td>

      <td>
        {data.payment_status_obj ? (
          <Badge bg={data.payment_status_obj.type}>
            {data.payment_status_obj.title}
          </Badge>
        ) : (
          "—"
        )}
      </td>

      <td>{data.city || "—"}</td>
      <td>{data.country || "—"}</td>
      <td>{formatDate(data.createdAt) || "—"}</td>
      <td>{formatDate(data.updatedAt) || "—"}</td>

      <td className="text-center" style={{ minWidth: "180px" }}>
        <span style={{ cursor: "pointer" }} onClick={() => viewEntry(data)}>
          <i className={"bi bi-eye text-info me-2"}></i>
        </span>
        {user?.role === "admin" && (
          <>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => updateEntry(data)}
            >
              <i className={"bi bi-pen text-warning me-2"}></i>
            </span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => deleteEntry(data)}
            >
              <i className={"bi bi-trash text-danger"}></i>
            </span>
          </>
        )}
      </td>
    </tr>
  );
};

const AdminAffiliatesTable = ({
  list = [],
  viewEntry,
  updateEntry,
  deleteEntry,
  user = {},
}) => {
  let i = 1;
  return (
    <Table responsive hover bordered style={{ fontSize: "14px" }}>
      <thead>
        <tr className="text-center">
          <th style={{ minWidth: "50px" }}>#</th>
          <th style={{ minWidth: "250px" }}>Name</th>
          <th style={{ minWidth: "180px" }}>Email</th>
          <th style={{ minWidth: "150px" }}>Phone</th>
          <th style={{ minWidth: "150px" }}>Username</th>
          <th style={{ minWidth: "180px" }}>Referral Code</th>
          <th style={{ minWidth: "180px" }}>Referrence By Code</th>
          <th style={{ minWidth: "120px" }}>Role</th>
          <th style={{ minWidth: "120px" }}>Status</th>
          <th style={{ minWidth: "120px" }}>Payment</th>
          <th style={{ minWidth: "120px" }}>City</th>
          <th style={{ minWidth: "120px" }}>Country</th>
          <th style={{ minWidth: "160px" }}>Created At</th>
          <th style={{ minWidth: "160px" }}>Updated At</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {list?.map((entry, index) => (
          <TableRow
            data={entry}
            key={index}
            sr={i++}
            propLength={list?.length}
            viewEntry={viewEntry}
            updateEntry={updateEntry}
            deleteEntry={deleteEntry}
            user={user}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default AdminAffiliatesTable;
